import { render, staticRenderFns } from "./AdminBar.vue?vue&type=template&id=147b22a8&scoped=true&"
import script from "./AdminBar.vue?vue&type=script&lang=js&"
export * from "./AdminBar.vue?vue&type=script&lang=js&"
import style0 from "./AdminBar.vue?vue&type=style&index=0&id=147b22a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b22a8",
  null
  
)

component.options.__file = "AdminBar.vue"
export default component.exports